'use client'
import React from 'react'
import HeroCard from '@/components/Cards/HeroCard'
import { Heading } from '@/components/Common'
import { useNews } from '@/hooks/useNews'
import LargeCard from '@/components/Cards/LargeCard'

const EntertainmentSection = () => {
  const { allNews, isLoading } = useNews({
    menuSlug: 'van-hoa',
  })
  const { allNews: entertainmentNews, isLoading: entertainmentLoading } = useNews({
    menuSlug: 'giai-tri',
  })
  return (
    <section className="container mt-4">
      <Heading>Văn hoá - Giải trí</Heading>
      <div className="grid grid-cols-12 gap-4">
        {/* Cột bên trái */}
        <div className="col-span-12 md:col-span-6 grid grid-cols-2 gap-4 overflow-y-auto max-h-[576px]">
          {isLoading
            ? Array.from({ length: 4 }).map((_, index) => (
                <div key={index} className="col-span-1">
                  <HeroCard isLoading />
                </div>
              ))
            : allNews.map((news) => (
                <div key={news.id} className="col-span-1">
                  <HeroCard
                    title={news.title}
                    categoryName={news.categoryName}
                    categoryId={news.categoryId}
                    imageUrl={news.imageUrl}
                    link={news.slug}
                  />
                </div>
              ))}
        </div>

        {/* Cột bên phải */}
        <div className="col-span-12 md:col-span-6">
          <LargeCard data={entertainmentNews} isLoading={entertainmentLoading} />
        </div>
      </div>
    </section>
  )
}

export default EntertainmentSection
